import 'moment/locale/fr'
import './form.css'

import { AutoForm, Footer, Header, Loading } from '../../Components';
import React, { useEffect, useState } from 'react';
import { authHeader, handleResponse } from '../../Helpers';

import EnglishResourceBundle from './locale/form.en.json'
import FrenchResourceBundle from './locale/form.fr.json'
import Moment from 'react-moment'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Form = () => {
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'form', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'form', FrenchResourceBundle);

    const { clientKey, key, recipientEmail, number, ea } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isFormUnknown, setIsFormUnknown] = useState(false);

    const safeJSONParse = (json) => {
        let result = {};

        try {
            result = JSON.parse(json);
        }
        catch {
        }

        return result;
    }

    const [scripts, setScripts] = useState([]);

    const onSave = (json) => {
        if (json === null)
            return;

        setData({ ...data, form: json.form, formModel: json.formModel, formVersion: json.formVersion });
    }

    const getLocalizeValue = (obj, culture, name) => {
        let localizeObj = obj && obj[culture.substring(0, 2)] ? obj[culture.substring(0, 2)] : null;

        if (localizeObj == null) {
            const keys = Object.keys(obj);
            if (keys.length > 0)
                localizeObj = obj[keys[0]];
        }

        return localizeObj[name] ? localizeObj[name] : "";
    }

    useEffect(() => {
        if (!i18n.language)
            return;

        const runScripts = (json) => {
            scripts.map(s => document.body.removeChild(s));

            let newScripts = [...scripts];

            if (json.client.javascript) {
                const scriptClient = document.createElement('script');
                scriptClient.innerHTML = json.client.javascript;
                scriptClient.async = true;
                document.body.appendChild(scriptClient);
                newScripts = [...newScripts, scriptClient];
            }

            if (json.template.javascript) {
                const scriptTemplate = document.createElement('script');
                scriptTemplate.innerHTML = json.template.javascript;
                scriptTemplate.async = true;
                document.body.appendChild(scriptTemplate);
                newScripts = [...newScripts, scriptTemplate];
            }

            setScripts(newScripts);
        }

        const request = {
            method: "GET",
            headers: authHeader()
        }

        const route = ea && ea.length > 0 ? `/q/${ea}` : `/${clientKey}/${recipientEmail}/forms/${key}/${number}`;

        fetch(`${process.env.REACT_APP_APIURL}/api/forms${route}?culture=${i18n.language.substring(0, 2)}`, request)
            .then(response => {
                if (!response.ok) {
                    setIsFormUnknown(true);
                    setLoading(false);
                    return;
                }

                return response;
            })
            .then(handleResponse)
            .then(json => {
                json.template.content = safeJSONParse(json.template ? json.template.content : "");
                json.formModel = safeJSONParse(json.formModel ? json.formModel : "");
                json.form.defaultModel = safeJSONParse(json.form ? json.form.defaultModel : "");

                setData(json);
                setLoading(false);

                runScripts(json);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    return (
        <div className="container-fluid">
            <Header />
            {loading ? (
                <Loading />
            ) : isFormUnknown ? (
                <div className="container">
                    <div className="alert alert-warning mt-4 mb-0" role="alert">
                        <p><strong>{t("form:unknown")}</strong></p>
                        <ul>
                            <li>{t("form:unknownWhy1")}</li>
                            <li>{t("form:unknownWhy2")}</li>
                            <li>{t("form:unknownWhy4")}</li>
                            <li>{t("form:unknownWhy3")}</li>
                        </ul>
                        <p>{t("form:unknownTryAgain")}</p>
                    </div>
                </div>
            ) : (
                        <>
                            {data.client.style && <style>{data.client.style}</style>}
                            {data.template.style && <style>{data.template.style}</style>}
                            <div className={data.template.content.container ? data.template.content.container : 'container'}>
                                <div className="row row-eq-height row-header">
                                    {getLocalizeValue(data.clientLocalizations, i18n.language, "logo") &&
                                        <div className="col-auto">
                                            <img className="header-logo" alt={getLocalizeValue(data.clientLocalizations, i18n.language, "name")} src={getLocalizeValue(data.clientLocalizations, i18n.language, "logo")}></img>
                                        </div>
                                    }
                                    <div className="col col-header-left">
                                        <div className="col-header-body">
                                            <p>{getLocalizeValue(data.clientLocalizations, i18n.language, "name")}</p>
                                        </div>
                                    </div>
                                    <div className="col col-header-right">
                                        <div className="col-header-body">
                                            <p>&nbsp;</p>
                                            <ul className="list-inline mb-0">
                                                {data.client && data.client.phone && <li className="list-inline-item">{t("form:phone")} <a href={`tel:${data.client.phone}`}>{data.client.phone}</a></li>}
                                                {data.client && data.client.fax && <li className="list-inline-item">{t("form:fax")} {data.client.fax}</li>}
                                                {data.client && data.client.email && <li className="list-inline-item">{t("form:email")} <a href={`mailto:${data.client.email}`}>{data.client.email}</a></li>}
                                                {data.client && getLocalizeValue(data.clientLocalizations, i18n.language, "website") && <li className="list-inline-item"><a href={getLocalizeValue(data.clientLocalizations, i18n.language, "website")} target="_blank" rel="noopener noreferrer">{getLocalizeValue(data.clientLocalizations, i18n.language, "website") ? getLocalizeValue(data.clientLocalizations, i18n.language, "website").replace(/(^\w+:|^)\/\//, '').toLowerCase() : ""}</a></li>}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="row row-title">
                                    <div className="col pt-0 pb-0">
                                        <h1 className="mb-0">{getLocalizeValue(data.templateLocalizations, i18n.language, "name")}</h1>
                                        <ul className="list-inline mb-0">
                                            <li className="list-inline-item"><small className="text-muted">{t("form:createdOn")} <b><Moment utc local locale={i18n.language.substring(0, 2)} date={data.form.creationDate} format="LLLL"></Moment></b></small></li>
                                            <li className="list-inline-item"><small className="text-muted">{t("form:modifiedOn")} <b><Moment utc local locale={i18n.language.substring(0, 2)} date={data.formVersion.modificationDate} fromNow></Moment></b></small></li>
                                        </ul>
                                        <p className="lead my-3">{getLocalizeValue(data.templateLocalizations, i18n.language, "description")}</p>
                                        <small className="red">*</small> <small className="text-muted">{t("form:requiredFieldsNote")}</small>
                                    </div>
                                </div>

                                <div className="row flex-nowrap justify-content-between align-items-center no-print">
                                    <div className="col d-flex justify-content-end align-items-center pt-0 pb-0">
                                        <button onClick={() => window.print()} type="button" className="btn btn-sm btn-outline-secondary">{t("form:print")}</button>
                                    </div>
                                </div>

                                <main role="main" >
                                    <div className="row">
                                        <div className="col-md-12 order-md-1">
                                            <AutoForm data={data} onSave={onSave} clientKey={clientKey} recipientEmail={recipientEmail} ea={ea} formKey={key} formNumber={number} />
                                        </div>
                                    </div>
                                </main>
                            </div>
                        </>
                    )}
                <Footer />
        </div>
    )
}